module.exports = __webpack_public_path__ + "de0ada8e8238d864563dee8695981fd6.svg";